import React from 'react'
import PersonalLoansForm from './Components/PersonalLoansForm'

const PersonalLoans = () => {
    return (
        // {/* x---------------------------------x PersonalLoan Form x---------------------------------x */ }
        <div className="grid grid-cols-1" >
            <div className="card h-100">
                <div className="card-header justify-between">
                    <h3 className="text-dark sm:text-2xl text-lg font-semibold p-3 pt-0">Apply for a Personal loan</h3>
                </div>
                <div className="card-body sm:p-6 p-4 rounded-2xl">
                    {/* x---------------------------------x PersonalLoan Form Section x---------------------------------x */}
                    <PersonalLoansForm />
                </div>
            </div>
        </div>
    )
}

export default PersonalLoans